import React from 'react';
import Icon from '../../../components/AppIcon';

const CoreValueBlocks = () => {
  const values = [
    {
      icon: 'Search',
      title: 'Unified Knowledge Hub',
      description: 'AI search across Drive, SharePoint, Notion, Confluence & Slack.'
    },
    {
      icon: 'Zap',
      title: 'Actionable Workflows',
      description: 'Onboarding → IT gear → HR requests → automatic execution.'
    },
    {
      icon: 'Award',
      title: 'Culture & Gamified Growth',
      description: 'Employee leveling system, recognition, badge achievements.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#0F0F11] to-[#0B1220]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values?.map((value, index) => (
            <div
              key={index}
              className="group backdrop-blur-xl bg-white/5 border border-white/10 rounded-3xl p-8 hover:bg-white/10 hover:border-[#FFD100]/40 hover:shadow-2xl hover:shadow-[#FFD100]/10 transition-all duration-500">
              <div className="w-16 h-16 bg-[#FFD100]/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#FFD100]/20 group-hover:scale-110 transition-all duration-300">
                <Icon name={value?.icon} size={32} color="#FFD100" strokeWidth={2} />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{value?.title}</h3>
              <p className="text-white/70 leading-relaxed">{value?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValueBlocks;